module.exports = __webpack_public_path__ + "static/media/elevat.8eec5b0a.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/chile/climasense/botrytis_pimiento/curativa/elevat.png
// module id = 1437
// module chunks = 3